const map = {
	"./DefaultDoor.png": 33741,
	"./birch.png": 14984,
	"./cambridge.png": 48336,
	"./continental.png": 81761,
	"./craftsman.png": 2941,
	"./handing_left.jpg": 4659,
	"./handing_right.jpg": 70656,
	"./pine-div-lite.png": 19847,
	"./pine.png": 2154,
	"./primed-lite.png": 54302,
	"./rockport.png": 34974,
	"./santa_fe.png": 23257,
	"./smooth_colonist.png": 27648,
	"./textured_colonist.png": 23107
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92910;